export default "__VITE_ASSET__a054dc86__"